import styled from 'styled-components';

export const StyledFinancingIcon = styled.svg`
    display: block;
`;
